import axios from "axios"
import { saveAs } from "file-saver" // (Bleibt für andere Funktionen erhalten)

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal // Der wichtigste Teil: Hängt das Token automatisch an

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}

export default {
  fetchLeadershipConnect() {
    const url = buildUrl("chat/leadership-connect")
    return axios.get(url, buildOptions()).then((response) => response.data)
  },
  fetchLeadershipChatContact() {
    const url = buildUrl("chat/leadership-contact")
    return axios.get(url, buildOptions())
  },
  startLeadershipContactChat() {
    const url = buildUrl("chat/leadership-contact/start")
    return axios.post(url, {}, buildOptions())
  },
  leaveChatGroup(groupId) {
    const url = buildUrl(`chat/groups/${groupId}/leave`)
    return axios.post(url, {}, buildOptions())
  },
  deleteChatGroup(groupId) {
    const url = buildUrl(`chat/groups/${groupId}/delete`)
    return axios.post(url, {}, buildOptions())
  },
  fetchGroupMedia(groupId, page = 0) {
    const url = buildUrl(`chat/groups/${groupId}/media`)
    const options = {
      params: {
        page: page,
      },
    }
    return axios.get(url, buildOptions(options))
  },
  fetchSecuredMedia(filename) {
    const url = buildUrl(`chat/media/${filename}`)
    return axios.get(url, {
      responseType: "blob", // Besser 'blob' statt 'arraybuffer', um konsistent mit dem PDF Code zu sein
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    })
  },
  uploadChatMedia(groupId, formData) {
    const url = buildUrl(`chat/groups/${groupId}/media`)
    return axios.post(url, formData, buildOptions({ headers: { "Content-Type": "multipart/form-data" } }))
  },
  fetchCommonGroups(targetUserId) {
    const url = buildUrl(`chat/users/${targetUserId}/common-groups`)
    return axios.get(url, buildOptions())
  },
  createGroup(groupData) {
    const url = buildUrl("chat/groups") // Wir übergeben die 'groupData' als Body der POST-Anfrage // 'buildOptions' hängt automatisch den Auth-Header an
    return axios.post(url, groupData, buildOptions())
  },
  fetchEligibleDirectChatUsers() {
    const url = buildUrl("chat/eligible-users")
    return axios.get(url, buildOptions())
  },
  createOrGetDirectChat(targetUserId) {
    const url = buildUrl("chat/one-on-one")
    return axios.post(url, { targetUserId }, buildOptions())
  },
  addChatMembers(groupId, memberIds) {
    const url = buildUrl(`chat/groups/${groupId}/members`)
    const payload = { memberIds } // Die API erwartet ein Objekt mit 'memberIds'
    return axios.post(url, payload, buildOptions())
  },
  /**
   * Holt alle Chat-Gruppen für den eingeloggten User
   */ fetchGroups() {
    const url = buildUrl("chat/groups")
    return axios.get(url, buildOptions())
  },
  fetchPinboard() {
    const url = buildUrl("chat/pins")
    return axios.get(url, buildOptions())
  },
  savePersonalPin(messageId) {
    const url = buildUrl(`chat/messages/${messageId}/save`)
    return axios.post(url, {}, buildOptions())
  },
  removePersonalPin(messageId) {
    const url = buildUrl(`chat/messages/${messageId}/save`)
    return axios.delete(url, buildOptions())
  },
  saveGlobalPin(messageId) {
    const url = buildUrl(`chat/messages/${messageId}/pin`)
    return axios.post(url, {}, buildOptions())
  },
  removeGlobalPin(messageId) {
    const url = buildUrl(`chat/messages/${messageId}/pin`)
    return axios.delete(url, buildOptions())
  },
  fetchMessagesForGroup(groupId, page = 1) {
    let options = buildOptions()
    options.params = {
      page: page,
      limit: 50, // (Stelle sicher, dass dies mit dem Backend übereinstimmt)
    }
    const url = buildUrl(`chat/groups/${groupId}/messages`)
    return axios.get(url, options)
  },
  updateGroup(groupId, updateData) {
    // updateData = { name, description, bild }
    const url = buildUrl(`chat/groups/${groupId}`)
    return axios.put(url, updateData, buildOptions())
  },
  searchGroupMessages(groupId, query) {
    const url = buildUrl(`chat/groups/${groupId}/search`)
    return axios.get(url, buildOptions({ params: { q: query } }))
  },

  getMessagePageContext(groupId, messageId) {
    const url = buildUrl(`chat/groups/${groupId}/message/${messageId}/context`)
    return axios.get(url, buildOptions())
  },
  /**
   * Entfernt ein Mitglied aus einer Gruppe
   */
  kickChatMember(groupId, userIdToRemove) {
    const url = buildUrl(`chat/groups/${groupId}/members/${userIdToRemove}`)
    return axios.delete(url, buildOptions())
  },

  /**
   * Ändert die Rolle eines Mitglieds
   */
  updateChatMemberRole(groupId, userIdToUpdate, newRole) {
    const url = buildUrl(`chat/groups/${groupId}/members/${userIdToUpdate}`)
    return axios.put(url, { role: newRole }, buildOptions())
  },
  startSupportChat() {
    const url = buildUrl("chat/support/start")
    return axios.post(url, {}, buildOptions())
  },
  acceptChatPolicy() {
    const url = buildUrl("chat/accept-policy")
    return axios.post(url, {}, buildOptions())
  },
}
